import http from '@/utils/http'

export const getRepaymentPlan = (params) =>
  http('/product/getRepaymentPlan', {}, 'GET', params)
